import api from "../../api/api";
import axios from "axios";
export const SAVE_SERVICE_TYPE = "SAVE_SERVICE_TYPE";
export const GET_PAGE_PATH = "GET_PAGE_PATH";
export const SAVE_SELECTION_VALUE = 'SAVE_SELECTION_VALUE';
export const CHANGE_VERFICATION_STATE = 'CHANGE_VERFICATION_STATE';

export function getServiceType(id, url) {
  let reqList = [];
  let userId = `{"Id":${id}}`;
  let method = "";
   // eslint-disable-next-line
  let apiPath = "";
  url.forEach(async val => {
    let keys = Object.keys(val);
    // eslint-disable-next-line
    for (let j in keys) {
      method = keys[j];
    }
    /*eslint-env es6*/
    // eslint-disable-next-line
    for (let i in val) {
      if ( val[i] === "api/ReferenceDataService/RetrievePostingTenureTypesByClient" ){
          apiPath = `${val[i]}?id=${1}`;
        }else　if(val[i] === "api/ReferenceDataService/RetrieveTitlesById"){
          apiPath = `${val[i]}?id=${id}`;
      } else if (
        val[i] ===
        "api/ReferenceDataService/RetrieveReasonForRelocationSubTypes"
      ) {
         // eslint-disable-next-line
        [1, 2].forEach(async index => {
          apiPath = val[i];
          let request = api.request(
            apiPath,
            method,
            `{"Id":${null},"ReasonForRelocationTypeId":${index === 1 ? 1 : 2}}`
          );
          reqList.push(request);
        });
      } else {
        apiPath = val[i];
      }
    }
    let req = api.request(apiPath, method, userId);
    reqList.push(req);
  });
  return dispatch => {
    try{
      axios.all(reqList).then(result => {
        const array = result.filter(data => {
          return data.Successful === true;
        });
        dispatch(saveServiceType(array));
      });
    }catch(err){
    }
  };
}
export function saveServiceType(type) {
  return {
    type: SAVE_SERVICE_TYPE,
    data: type
  };
}
export function getPagePath(url) {
  return {
    type: GET_PAGE_PATH,
    data: url
  };
}
export function saveSelectionValue(data){
  return {
    type: SAVE_SELECTION_VALUE,
    data: data
  };
}
export function changeVerficationState(statue){
  return {
    type: CHANGE_VERFICATION_STATE,
    data: statue
  };
}
